export enum SORT_DIRECTION {
  ASC = 'asc',
  DESC = 'desc',
}

export enum COMPONENT_TAG_LIST_COLUMN {
  NAME = 'name',
  COMPONENTS_COUNT = 'components_count',
  ACTIONS = 'actions',
}

export interface Column {
  label: string;
  key: COMPONENT_TAG_LIST_COLUMN;
  sortIcon: boolean;
}
